


function ServicioPagoReserva({ servicio, reserva }) {
    
  const imagenServicio = servicio?.imagen?.[0] || servicio?.imagenes?.[0] || "";
  const nombreServicio = servicio?.nombre || servicio?.titulo || "NA";
  const descripcionServicioExtracto = servicio?.descripcion || "";
  const tipoServicio = servicio?.tipo || servicio?.tipoServicio || "NA";
  const paquetesServicio = Array.isArray(servicio?.paquetes) ? servicio.paquetes : [];
  const tipoPaqueteSeleccionado = reserva?.tipoPaquete || servicio?.tipoPaquete || "NA";
  const paqueteSeleccionado = paquetesServicio.find((paq) => {
    const tipoPaq = (paq?.tipo || "").toString().trim().toLowerCase();
    const tipoSeleccionado = tipoPaqueteSeleccionado.toString().trim().toLowerCase();
    return tipoPaq === tipoSeleccionado;
  });
  const paqueteExtracto = paqueteSeleccionado?.descripcion || "";
  const tipoPresencial = servicio?.tipoDesplazamiento || servicio?.tipoPresencial || "NA";
  const pais = servicio?.pais || "NA";
  const ciudad = servicio?.ciudad || "NA";
  const zona = servicio?.zona || "NA";
  const subzonaTexto = Array.isArray(servicio?.subzonas)
    ? servicio.subzonas.join(", ")
    : (servicio?.subzona || servicio?.subzonaTexto || "NA");

  return (
    <div
      className="border rounded-4 p-3 p-md-4 mt-3"
      style={{ background: "var(--color-bg-surface)", borderColor: "var(--color-border)" }}
    >
      {/* TITULO E IMAGEN */}
      <div className="d-flex align-items-start justify-content-between gap-3 mb-3 flex-wrap">
        {/* ICONO,TITULO Y DESCRIPCIÓN */}
        <div className="d-flex align-items-center gap-2">
          {/* ICONO */}
          <div
            className="d-flex align-items-center justify-content-center rounded-circle"
            style={{
              width: 38,
              height: 38,
              background: "rgba(var(--naranja-cta-rgb), 0.10)",
              color: "var(--naranja-cta)",
              flexShrink: 0,
            }}
          >
            <i className="bi bi-briefcase"></i>
          </div>

          {/* TITULO Y DESCRIPCIÓN */}
          <div>
            <div className="fw-bold" style={{ color: "var(--color-text-primary)" }}>
              Información del servicio
            </div>
            <div className="text-body-secondary" style={{ fontSize: 13 }}>
              Detalles generales del servicio reservado.
            </div>
          </div>
        </div>

        {/* IMAGEN */}
        {imagenServicio ? (
          <img
            src={imagenServicio}
            alt="Servicio"
            style={{
              width: 70,
              height: 70,
              objectFit: "cover",
              borderRadius: 16,
              flexShrink: 0,
              border: "1px solid var(--color-border)",
            }}
          />
        ) : null}
      </div>

      {/* NOMBRE Y TIPO */}
      <div className="row g-3">
        {/* NOMBRE Y DESCRIPCIÓN */}
        <div className="col-12 col-md-9">
          <div
            className="text-body-secondary mb-1"
            style={{ fontSize: 12, textTransform: "uppercase", letterSpacing: 0.3 }}
          >
            Nombre del servicio
          </div>
          <div className="fw-semibold" style={{ color: "var(--color-text-primary)" }}>
            {nombreServicio}
          </div>

          {descripcionServicioExtracto ? (
            <div
              className="text-body-secondary mt-0"
              style={{
                fontSize: 14,
                lineHeight: 1.55,
                display: "-webkit-box",
                WebkitLineClamp: 3,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
              }}
            >
              {descripcionServicioExtracto}
            </div>
          ) : null}
        </div>

        {/* TIPO DE SERVICIO */}
        <div className="col-12 col-md-3">
          <div
            className="text-body-secondary mb-1"
            style={{ fontSize: 12, textTransform: "uppercase", letterSpacing: 0.3 }}
          >
            Tipo de servicio
          </div>
          <div className="fw-semibold" style={{ color: "var(--color-text-primary)" }}>
            {tipoServicio}
          </div>
        </div>

        {/* PAQUETE Y PRESENCIAL */}
        <div className="col-12 col-md-9">
          <div
            className="text-body-secondary mb-1"
            style={{ fontSize: 12, textTransform: "uppercase", letterSpacing: 0.3 }}
          >
            Paquete seleccionado
          </div>
          <div className="fw-semibold" style={{ color: "var(--color-text-primary)" }}>
            {tipoPaqueteSeleccionado}
          </div>

          {paqueteExtracto ? (
            <div
              className="text-body-secondary mt-0"
              style={{
                fontSize: 14,
                lineHeight: 1.55,
                display: "-webkit-box",
                WebkitLineClamp: 3,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
              }}
            >
              {paqueteExtracto}
            </div>
          ) : null}
        </div>

        {/* INFO UBICACIÓN */}
        {tipoServicio === "Presencial" ? (
          <>
            <div className="col-12 col-md-3">
              <div
                className="text-body-secondary mb-1"
                style={{ fontSize: 12, textTransform: "uppercase", letterSpacing: 0.3 }}
              >
                Tipo de presencial
              </div>
              <div className="fw-semibold" style={{ color: "var(--color-text-primary)" }}>
                {tipoPresencial}
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-3">
              <div
                className="text-body-secondary mb-1"
                style={{ fontSize: 12, textTransform: "uppercase", letterSpacing: 0.3 }}
              >
                País
              </div>
              <div className="fw-semibold" style={{ color: "var(--color-text-primary)" }}>
                {pais}
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-3">
              <div
                className="text-body-secondary mb-1"
                style={{ fontSize: 12, textTransform: "uppercase", letterSpacing: 0.3 }}
              >
                Ciudad
              </div>
              <div className="fw-semibold" style={{ color: "var(--color-text-primary)" }}>
                {ciudad}
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-3">
              <div
                className="text-body-secondary mb-1"
                style={{ fontSize: 12, textTransform: "uppercase", letterSpacing: 0.3 }}
              >
                Zona
              </div>
              <div className="fw-semibold" style={{ color: "var(--color-text-primary)" }}>
                {zona}
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-3">
              <div
                className="text-body-secondary mb-1"
                style={{ fontSize: 12, textTransform: "uppercase", letterSpacing: 0.3 }}
              >
                Subzona
              </div>
              <div className="fw-semibold" style={{ color: "var(--color-text-primary)" }}>
                {subzonaTexto}
              </div>
            </div>
          </>
        ) : null}
      </div>
    </div>
  );
}

export default ServicioPagoReserva;